import { registerRequestSignInterceptor } from '@patsnap/common-ps-http/dist/RequestSignInterceptor';
import { sign } from '@patsnap/common-ps-http/dist/crypto';
import { psAxios } from '@patsnap/common-ps-http';

const coreBasicApiUrlPrefix = `${import.meta.env.VITE_CORE_BASIC_SERVICE_URI}/core-basic-api`;

function fetchWithTimeout(url: string, options: any, timeout: number) {
    return new Promise((resolve, reject) => {
        const timer = setTimeout(() => {
            reject(new Error('timeout'));
        }, timeout);

        fetch(url, options)
            .then(res => {
                clearTimeout(timer);
                resolve(res);
            })
            .catch(err => {
                clearTimeout(timer);
                reject(err);
            });
    });
}

let signInterceptor: any = null;

/**
 * 注入签名拦截器
 */
export function injectSignInterceptor() {
    if (signInterceptor) {
        return;
    }

    signInterceptor = registerRequestSignInterceptor(
        psAxios as any,
        {
            detectResponseShouldRefresh(_response: any) {
                return false;
            },
            getServiceTimeStamp() {
                const now = Date.now();
                return fetchWithTimeout(
                    `${coreBasicApiUrlPrefix}/analytics/security/timestamp?lt=${now}`,
                    {},
                    11000,
                )
                    .then((res: any) => res.json())
                    .then(d => parseInt(d.data, 10))
                    .catch(() => Date.now());
            },
            detectShouldSignRequest(_config: any, fullUrl: string) {
                return fullUrl.includes('basic-service.zhihuiya.com') ||
                    fullUrl.includes('search-service.zhihuiya.com');
            },
        },
    );

    signInterceptor.syncServiceTime();
    signInterceptor.sign = sign;
}

/**
 * 移除签名拦截器
 */
export function ejectSignInterceptor() {
    signInterceptor = null;
}
